module.exports = __webpack_public_path__ + "static/media/history_14.6af14bbf.jpg";